import {
  Box,
  Button,
  Card,
  // Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import TitleText from '../../components/formlib/TitleText';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  SELECTED_PROGRAM_KEY,
} from '../../services/Constant';
import { OptionType, Order, SnackbarType } from '../../utils/type';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import MediumTypography from '../../components/formlib/MediumTypography';
import { HeadCell, TableHeader } from '../../components/formlib/TableHeader';
import { ActivitySheetEmployeeResponse, ReviewEmployeeHeader } from './types';
import { getReviewActivitySheetHeaders } from './activityUtils';
import ActivitySheetEmployeeRow from './ActivitySheetEmployeeRow';
import { formatDate, getFiscalYearInfo } from '../../utils/dateUtil';
import AppPagination from '../../components/shared/AppPagination';
import { useLocation, useNavigate } from 'react-router';
import { ACTIVITY_APPROVAL_SHEET_ROUTE_NAME } from '../../routes/Routing';
import SearchBox from '../../components/formlib/SearchBox';
import { getAllEmployeesActivitySheet } from '../../services/configApi/activitySheet/weeklyActivitySheetProvider';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import { ApiError, isCustomError } from '../../services/ApiResponseHandler';
import WeekDatePicker from '../../components/formlib/modal/WeekDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import HolidayListDialog from '../holidays/HolidayListDialog';
import {
  Holiday,
  getHolidayList,
} from '../../services/configApi/employees/holidayServices';
import { Context } from '../../LanguageWrapper';
import { ReactComponent as Filtericon } from '../../assets/images/FilterIconsvg.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MultipleAutocompleteSearch from '../../components/formlib/MultipleAutocompleteSearch';
import CustomMenu from '../../components/formlib/CustomMenu';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import DisplayFilter, { FilterBy } from '../../components/shared/DisplayFilter';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setReviewActivitySheetFilter } from '../../redux/features/reviewActivitySheet/reviewActivitySheetFilterSlice';
import { debounce } from 'lodash';


export const FilterStatuses: string[] = [
  'notSubmitted',
  'pending',
  'rejected',
  'approved',
];
const billingStatusFilters: OptionType[] = [
  { id: 'notSubmitted', label: 'Not Submitted' },
  { id: 'pending', label: 'Pending' },
  { id: 'rejected', label: 'Rejected' },
  { id: 'approved', label: 'Approved' },
];

const payrollStatusFilters: OptionType[] = [
  { id: 'notSubmitted', label: 'Not Submitted' },
  { id: 'submitted', label: 'Submitted' },
  { id: 'approved', label: 'Approved' },
];

const ActivitySheetOverview = () => {
  const rctl = useIntl();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const reviewActivitySheetFilters = useAppSelector(
    (state) => state.reviewActivitySheetFilter,
  );
  const navigate = useNavigate();
  const [showHolidays, setShowHolidays] = useState<boolean>(false);
   const [selectedDate, setSelectedDate] = useState<Date>(
    location.state ? location.state.date : new Date(),
  );
  const [selectedProgram, setSelectedProgram] = useState<OptionType | null>(
    null,
  );
  const [selectedPayrollStatus, setSelectedPayrollStatus] = useState<
    OptionType[]
  >(
    (reviewActivitySheetFilters.status.find(
      (item) => item.key === 'payrollStatusText',
    )?.value as OptionType[]) || [],
  );

  const [selectedBillingStatus, setSelectedBillingStatus] = useState<
    OptionType[]
  >(
    reviewActivitySheetFilters.status.find(
      (item) => item.key === 'billingStatusText',
    )?.value as OptionType[],
  );

  const [order, setOrder] = useState<Order>('asc');
  const [orderBy, setOrderBy] =
    useState<keyof ReviewEmployeeHeader>('lastName');
  const context = useContext(Context);
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;
  const [employeeResponse, setEmployeeResponse] =
    useState<ActivitySheetEmployeeResponse | null>(null);
  const [toastr, setToastr] = useState<SnackbarType>({
    toasterId: null,
    defaultToasterMessage: '',
    toasterAction: 'info',
  });

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const MemorizedCustomMenu = useMemo(() => CustomMenu, []);

  const applyFilter = () => {
    const filterPayrollDataSet: FilterBy[] = [];
    const filterBillingDataSet: FilterBy[] = [];

    if (selectedPayrollStatus.length) {
      filterPayrollDataSet.push({
        key: 'payrollStatusText',
        value: selectedPayrollStatus,
      });
    }

    if (selectedBillingStatus.length) {
      filterBillingDataSet.push({
        key: 'billingStatusText',
        value: selectedBillingStatus,
      });
    }
    dispatch(
      setReviewActivitySheetFilter({
        ...reviewActivitySheetFilters,
        status: [...filterPayrollDataSet, ...filterBillingDataSet],
      }),
    );
  };

  const handlefilter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handlefilterClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const navParams = location.state;
    if (navParams !== null) {
      setSelectedDate(navParams.date as Date);
    }
  }, []);

  useEffect(() => {
    callAPI();
  }, [selectedDate, orderBy, order, reviewActivitySheetFilters]);

  const callAPI = useCallback(
    debounce(() => {
      getActivitySheetEmployees();
    }, 500),
    [selectedDate, orderBy, order, reviewActivitySheetFilters],
  );

  const getActivitySheetEmployees = () => {
    const billingStatus = reviewActivitySheetFilters.status.flatMap(
      (filter) => {
        if (
          typeof filter.value !== 'string' &&
          filter.value.length > 0 &&
          filter.key === 'billingStatusText'
        ) {
          return filter.value.map((value: OptionType) => value.label);
        }
        return [];
      },
    );

    const payrollStatus = reviewActivitySheetFilters.status.flatMap(
      (filter) => {
        if (
          typeof filter.value !== 'string' &&
          filter.value.length > 0 &&
          filter.key === 'payrollStatusText'
        ) {
          return filter.value.map((value: OptionType) => value.label);
        }
        return [];
      },
    );

    toggleLoader(true);
    getAllEmployeesActivitySheet(
      formatDate(selectedDate, 'MM/DD/YYYY'),
      reviewActivitySheetFilters.searchText || '',
      reviewActivitySheetFilters.pageNo || 0,
      orderBy,
      order,
      payrollStatus,
      billingStatus,
    )
      .then((response) => {
        toggleLoader(false);
        setEmployeeResponse(response);
      })
      .catch((error) => {
        toggleLoader(false);
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastr({
            toasterId: apiError.id,
            toasterAction: 'error',
            defaultToasterMessage: apiError.message,
          });
        } else {
          setToastr({
            toasterId: 'requestFailureMessage',
            toasterAction: 'error',
            defaultToasterMessage: 'Request Failure',
          });
        }
      });
  };

  const handleRequestSort = (
    _event: React.MouseEvent<unknown>,
    property: keyof ReviewEmployeeHeader,
  ) => {
    setOrder(order === 'asc' ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const readHolidayList = () => {
    const program = context.selectedProgram;
    if (!program || !selectedDate) {
      return;
    }
    toggleLoader(true);

    const { startYear, endYear } = getFiscalYearInfo(selectedDate);
    getHolidayList(startYear, endYear, program.id)
      .then((response) => {
        toggleLoader(false);
        setShowHolidays(true);
        setHolidays(response.holidayList);
      })
      .catch(() => {
        toggleLoader(false);
      });
  };

  useEffect(() => {
    const program = localStorage.getItem(SELECTED_PROGRAM_KEY);
    if (typeof program === 'string') {
      setSelectedProgram(JSON.parse(program) as OptionType);
    }
  }, []);

  const handleToasterClose = () => {
    setToastr({
      toasterId: null,
      toasterAction: 'info',
      defaultToasterMessage: '',
    });
  };

  const changeTextDebouncer = (input: string) => {
    dispatch(
      setReviewActivitySheetFilter({
        ...reviewActivitySheetFilters,
        searchText: input,
        pageNo: 0,
      }),
    );
  };

  const [headerCells, setHeaderCells] = useState<
    HeadCell<ReviewEmployeeHeader>[]
  >([]);

  useEffect(() => {
    setHeaderCells(getReviewActivitySheetHeaders());
  }, []);

  return (
    <Box component={'main'}>
      <Box component={'section'} sx={{ display: 'flex', marginTop: '24px' }}>
        {toastr.toasterId !== null && (
          <SnackBarComponent
            open={true}
            handleClose={handleToasterClose}
            successOrError={toastr.toasterAction}
            labelId={toastr.toasterId}
            defaultMessageId={toastr.defaultToasterMessage}
          />
        )}
        {showHolidays && (
          <HolidayListDialog
            open={showHolidays}
            date={selectedDate ?? new Date()}
            holidays={holidays}
            onClose={() => setShowHolidays(false)}
          />
        )}
       
        <Box sx={{ display: 'flex', width: '100%' }}>
          <TitleText
            label={`${rctl.formatMessage({
              id: 'reviewActivitySheetText',
            })}:`}
            defaultlabel="reviewActivitySheetText"
          />
          <TitleText
            label={`${selectedProgram === null ? '' : selectedProgram.label}`}
            defaultlabel="Program Name"
            Sxprops={{ color: '#008C82', marginLeft: '8px' }}
          />
       
        </Box>
      </Box>
      <Box component={'section'} sx={{ display: 'flex', marginTop: '16px' }}>
        <WeekDatePicker
          date={dayjs(selectedDate)}
          maxDate={dayjs().add(4, 'week').endOf('week')}
          onDateSelect={(newDate: Dayjs) => {
            setSelectedDate(newDate.toDate());
            dispatch(
              setReviewActivitySheetFilter({
                ...reviewActivitySheetFilters,
                pageNo: 0,
              }),
            );
          }}
        />

        <Box
          component={'section'}
          sx={{ display: 'flex', alignItems: 'center', marginLeft: '24px' }}
        >
          <MediumTypography
            sxProps={{ fontSize: '16px' }}
            labelid="employeeSubmitSheetText"
            defaultlabel="No. of employees submitted the Activity Sheet -"
          />
          <MediumTypography
            label={`${
              employeeResponse === null ? 0 : employeeResponse.submittedCount
            }`}
            defaultlabel="0 / 0"
            sxProps={{
              fontSize: '16px',
              color: '#008C82',
              marginLeft: '8px',
              fontWeight: 'bold',
            }}
          />
        </Box>

        <Box
          sx={{
            marginRight: '8px',
            alignSelf: 'center',
            marginLeft: 'auto',
          }}
          onClick={() => {
            readHolidayList();
          }}
        >
          <MediumTypography
            sxProps={{ color: '#008C82', cursor: 'pointer' }}
            labelid={`${rctl.formatMessage({
              id: 'holiday(s)Text',
              defaultMessage: 'Holiday(s)',
            })} ${dayjs().format('YYYY')}`}
            defaultlabel="Holiday(s)"
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', marginTop: '16px' }}>
        <SearchBox
          labelId="searchEmployeeText"
          defaultlabel="Search Employee"
          onChange={changeTextDebouncer}
          value={reviewActivitySheetFilters.searchText}
        />
        <Box sx={{ flexGrow: 1 }}></Box>
        <Box sx={{ display: 'flex' }}>
          <Button
            className="btn-primary btn-filter"
            variant="outlined"
            onClick={handlefilter}
            endIcon={<KeyboardArrowDownIcon />}
            startIcon={<Filtericon />}
          >
            <FormattedMessage id="FiterText" defaultMessage="Filter" />
          </Button>
          <MemorizedCustomMenu
            id="demo-customized-menu"
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handlefilterClose}
          >
            <Box>
              <MultipleAutocompleteSearch
                labelId="PayrollStatusText"
                defaultId="Payroll Status"
                data={payrollStatusFilters}
                value={selectedPayrollStatus}
                onSelectItem={(value) => setSelectedPayrollStatus(value)}
                sxProps={{ width: '400px' }}
              />
            </Box>
            <Box className="mt-lg">
              <MultipleAutocompleteSearch
                labelId="BillingStatusText"
                defaultId="Billing Status"
                data={billingStatusFilters}
                value={selectedBillingStatus}
                onSelectItem={(value) => setSelectedBillingStatus(value)}
                sxProps={{ width: '400px' }}
              />
            </Box>
            <Box
              className="mt-lg"
              sx={{
                justifyContent: 'right',
                display: 'flex',
              }}
            >
              <ButtonComponent
                className="btn-primary btn-cancel btn_width_90px mr-sm"
                variantType="contained"
                labelId="Dashboard.filtercancel"
                defaultLabelId="Cancel"
                onClick={() => {
                  setAnchorEl(null);
                  if (reviewActivitySheetFilters.status.length > 0) {
                    const payrollStatus =
                      reviewActivitySheetFilters.status.find(
                        (item) => item.key === 'payrollStatusText',
                      );

                    const billingStatus =
                      reviewActivitySheetFilters.status.find(
                        (item) => item.key === 'billingStatusText',
                      );
                    if (payrollStatus) {
                      setSelectedPayrollStatus(
                        payrollStatus.value as OptionType[],
                      );
                    }

                    if (billingStatus) {
                      setSelectedBillingStatus(
                        billingStatus.value as OptionType[],
                      );
                    }
                  }
                }}
                disabled={false}
              />

              <ButtonComponent
                className="btn-primary btn-submit btn_width_90px"
                variantType="contained"
                labelId="Dashboard.filtersubmit"
                defaultLabelId="Apply"
                onClick={() => {
                  setAnchorEl(null);
                  applyFilter();
                }}
                disabled={false}
              />
            </Box>
          </MemorizedCustomMenu>
        </Box>
      </Box>

      <Box>
        {reviewActivitySheetFilters.status.length > 0 && (
          <Box sx={{ marginTop: '16px' }}>
            <DisplayFilter
              filteredData={reviewActivitySheetFilters.status}
              handleCloseClickArrayType={(main: number, sub: number) => {
                const valueArray = reviewActivitySheetFilters.status[main]
                  .value as OptionType[];
                const removed = valueArray[sub];
                const newValue = valueArray.filter(
                  (_: OptionType, idx: number) => idx !== sub,
                );
                if (removed) {
                  // Remove from selectedStatus as well
                  setSelectedPayrollStatus(
                    selectedPayrollStatus.filter(
                      (status) => status.id !== removed.id,
                    ),
                  );

                  setSelectedBillingStatus(
                    selectedBillingStatus.filter(
                      (status) => status.id !== removed.id,
                    ),
                  );

                  // Update reviewActivitySheetFilters immutably
                  let newFilterBy;
                  if (newValue.length === 0) {
                    // Remove the entire filter group if no values left
                    newFilterBy = reviewActivitySheetFilters.status.filter(
                      (_: FilterBy, idx: number) => idx !== main,
                    );
                  } else {
                    // Update the value array for this filter group
                    newFilterBy = [...reviewActivitySheetFilters.status];
                    newFilterBy[main] = {
                      ...newFilterBy[main],
                      value: newValue,
                    };
                  }
                  dispatch(
                    setReviewActivitySheetFilter({
                      ...reviewActivitySheetFilters,
                      status: newFilterBy,
                    }),
                  );
                }
              }}
              handleClearClick={() => {
                dispatch(
                  setReviewActivitySheetFilter({
                    ...reviewActivitySheetFilters,
                    status: [],
                  }),
                );
                setSelectedPayrollStatus([]);
                setSelectedBillingStatus([]);
              }}
              sxProps={{ marginTop: '0px' }}
            />
          </Box>
        )}
      </Box>

      <Box component={'section'} sx={{ marginTop: '16px' }}>
        <Card sx={{ width: '100%' }}>
          <TableContainer>
            <Table
              sx={{ minWidth: 750, maxWidth: '100%' }}
              aria-labelledby="tableTitle"
              size={'medium'}
            >
              <TableHeader
                className="listDataTableHead"
                labelSxProp={{ whiteSpace: 'normal', padding: 'none' }}
                headerNames={headerCells}
                checkBoxRequired={false}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />
              <TableBody className="tableRowcss">
                {employeeResponse?.employeesReview.map((item) => {
                  return (
                    <ActivitySheetEmployeeRow
                      key={item.id}
                      data={item}
                      handleViewClick={(id: string) => {
                        navigate(ACTIVITY_APPROVAL_SHEET_ROUTE_NAME, {
                          state: {
                            id: id,
                            date: selectedDate,
                            firstName: item.firstName,
                            lastName: item.lastName,
                          },
                        });
                      }}
                    />
                  );
                })}
                {employeeResponse !== null &&
                  employeeResponse.employeesReview.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <Box
                          display={'flex'}
                          justifyContent={'center'}
                          padding={'16px'}
                        >
                          {reviewActivitySheetFilters.searchText.length ===
                          0 ? (
                            <MediumTypography
                              labelid="noRecordsFoundMessage"
                              defaultlabel="No records found"
                            />
                          ) : (
                            <MediumTypography
                              labelid="searchnotfound.smallText"
                              defaultlabel="We could not find any search results. Give it another go"
                            />
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>

          {employeeResponse !== null &&
            employeeResponse.totalEmployeeCount > 10 && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <AppPagination
                  pageNumber={reviewActivitySheetFilters.pageNo || 0}
                  paginationCount={employeeResponse.totalEmployeeCount}
                  handleChangePage={(_event, newPage) => {
                    if (newPage - 1 !== reviewActivitySheetFilters.pageNo) {
                      dispatch(
                        setReviewActivitySheetFilter({
                          ...reviewActivitySheetFilters,
                          pageNo: newPage - 1,
                        }),
                      );
                    }
                  }}
                />
              </Box>
            )}
        </Card>
      </Box>
    </Box>
  );
};

export default ActivitySheetOverview;
